<template>
    <div class="vuetable-filterbar col-md-12 ">
        <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="status"
                        :options="optionsStatus"
                        track-by="value"
                        label="label"
                        :option-height="25"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col cols="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_motivo"
                        :options="optionsTipoMotivo"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Motivo"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      cd: '',
      descr: '',
      optionsStatus: [],
      status: [],
      optionsTipoMotivo: [],
      tp_motivo: [],
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  mounted() {
      this.getStatus();
      this.getTipoMotivo();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {cd: this.cd,
                              descr: this.descr,
                              status: this.status,
                              tp_motivo: this.tp_motivo};
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';  // clear the text in text input
        this.descr = '';
        this.status = '';
        this.tp_motivo = '';
        this.$events.fire('filter-reset');
      },
      getStatus() {
          this.helpForm.params = { tabela: 'param_motivo',
                                  coluna: 'status' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsStatus.push({ label: obj.descr, value: obj.valor })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
      getTipoMotivo() {
          this.helpForm.params = { tabela: 'param_motivo',
                                  coluna: 'tp_motivo' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsTipoMotivo.push({ label: obj.descr, value: obj.valor })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      }
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>
